/**
 * Links to the operator's other properties.
 *
 * SarkariFormGuide.com is a separate project that will carry the form-filling
 * tools and step-by-step "how to fill this form" guides (photo/signature
 * resizing, document checklists, an age calculator) - the things students
 * currently pay a cyber cafe to do for them. Those tools are deliberately NOT
 * duplicated here; this site links out to them instead.
 *
 * The URL is not live yet, so it comes from the build environment and every
 * consumer renders nothing while it is unset. Set it in frontend/.env when the
 * site is ready and every entry point below lights up at once:
 *
 *   REACT_APP_FORM_GUIDE_URL=https://sarkariformguide.com
 */

const env = (name) => (process.env[name] || '').trim();

export const FORM_GUIDE_URL = env('REACT_APP_FORM_GUIDE_URL');

/**
 * Build a deep link to a guide for one exam when the sister site supports it,
 * falling back to its home page. Kept here so the URL shape lives in one place.
 */
export const formGuideLinkFor = (slug) => {
  if (!FORM_GUIDE_URL) return '';
  const base = FORM_GUIDE_URL.replace(/\/+$/, '');
  return slug ? `${base}/guide/${slug}` : base;
};
